// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-4e4c69b1] .el-dialog__body {\n  padding: 0 30px 20px !important;\n}\n", ""]);
// Exports
module.exports = exports;
